module.exports = __webpack_public_path__ + "assets/f4c20792b3555b7da46f9603d9fce53e.png";